import CreateWorkspaceStep from '../steps/create-workspace-step';
import DownloadStep from '../steps/download-step';
import PersonaRoleStep from '../steps/persona-role-step';
import SuggestedWorkspaceStep from '../steps/suggested-workspace-step';
import ValuePropStep from '../steps/value-prop-step';

import {
  DOWNLOAD_OPTIONS_STEP,
  PERSONA_USE_CASE_STEP,
  SUGGESTED_WORKSPACES_STEP,
  WORKSPACE_CREATE_STEP,
} from 'components/welcome-webapp-simplified/constants';

// Only custom step
export const VALUE_PROP_STEP = 'value-prop-step';

export const STEPS = {
  VALUE_PROP_STEP,
  PERSONA_USE_CASE_STEP,
  SUGGESTED_WORKSPACES_STEP,
  WORKSPACE_CREATE_STEP,
  DOWNLOAD_OPTIONS_STEP,
};

export const MAP_STEP_TO_COMPONENT = {
  [VALUE_PROP_STEP]: ValuePropStep,
  [PERSONA_USE_CASE_STEP]: PersonaRoleStep,
  [SUGGESTED_WORKSPACES_STEP]: SuggestedWorkspaceStep,
  [WORKSPACE_CREATE_STEP]: CreateWorkspaceStep,
  [DOWNLOAD_OPTIONS_STEP]: DownloadStep,
};

export const MAP_KEY_TO_STEP = {
  [VALUE_PROP_STEP]: 0,
  [PERSONA_USE_CASE_STEP]: 1,
  [SUGGESTED_WORKSPACES_STEP]: 2,
  [WORKSPACE_CREATE_STEP]: 2,
  [DOWNLOAD_OPTIONS_STEP]: 3,
};
